module.exports = __webpack_public_path__ + "static/img/posy_2.e7fcc8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/3dapps/skybox/tidepool/posy_2.jpg
// module id = bRdV
// module chunks = 2